<template>
  <BaseInnerSidebar>
    <template #title>
      Templates
    </template>
    <template #content>
      <nuxt-link
        v-for="(tab, index) in tabs"
        :key="index"
        :to="tab.route"
      >
        <BaseSidebarOption :is-active="tab.active">
          {{ tab.name }}
        </BaseSidebarOption>
      </nuxt-link>
    </template>
  </BaseInnerSidebar>
</template>

<script lang="ts" setup>
const route = useRoute()
const router = useRouter()

const routeName = computed(() => {
  return route.name as string
})

const { isAdmin, isOwner } = useRolePermissions()
const { t } = useI18n()

const { user, isLoaded } = useUser()

const isSupport = computed(() => {
  return user.value?.publicMetadata?.isAdmin || false
})

const tabs = computed(() => {
  if (isAdmin || isOwner || isSupport.value) {
    return [
      { name: 'Confidential Information Memorandum', route: { name: 'templates-cim' }, active: routeName.value === 'templates-cim' },
      { name: 'Appraisal', route: { name: 'templates-appraisal' }, active: routeName.value === 'templates-appraisal' },
      { name: 'Proposal', route: { name: 'templates-proposal' }, active: routeName.value === 'templates-proposal' },
      { name: 'Teaser', route: { name: 'templates-teaser' }, active: routeName.value === 'templates-teaser' },
      { name: 'NDA Manager', route: { name: 'templates-confidentiality-agreement' }, active: routeName.value === 'templates-confidentiality-agreement' },
      { name: 'Folders', route: { name: 'templates-folders' }, active: routeName.value === 'templates-folders' },
      { name: 'Menu Editor', route: { name: 'templates-resources' }, active: routeName.value === 'templates-resources' },
      { name: 'Forms', route: { name: 'templates-forms' }, active: routeName.value === 'templates-forms' },
      { name: 'SMS / Email', route: { name: 'templates-message' }, active: routeName.value === 'templates-message' },
      { name: 'Business Campaign', route: { name: 'templates-business-campaign' }, active: routeName.value === 'templates-business-campaign' },
    ]
  }
  else {
    return [
      { name: 'Confidential Information Memorandum', route: { name: 'templates-cim' }, active: routeName.value === 'templates-cim' },
      { name: 'Proposal', route: { name: 'templates-proposal' }, active: routeName.value === 'templates-proposal' },

    ]
  }
})
</script>
